var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('div',{staticClass:"center_text"},[_vm._v(" 湖南宁庆移动APP"),_c('br')]),_c('div',{staticClass:"url_text"},[_c('a',{attrs:{"href":"itms-services://?action=download-manifest&url=https://loc.tdlbs.com/release/yk/yk.plist"}},[_vm._v("点击下载")])])])
}]

export { render, staticRenderFns }